// extracted by mini-css-extract-plugin
module.exports = {"component":"mobile-carousel-component--3BcaF"};